import React, {useState} from 'react'
import {Helmet} from 'react-helmet'
import {useAuth} from 'app/modules/auth'
import {ToastContainer} from 'react-toastify'
import AddAudit from './components/drawer/AddAudit'
import EditAudit from './components/drawer/EditAudit'
import CompleteModal from './components/modal/CompleteModal'
import ConfirmationModal from 'app/components/ConfirmationModal'
import AuditHeader from './components/AuditHeader'
import AuditCard from './components/AuditCard'
import EmptyState from './components/EmptyState'
import {useAudits} from './hooks/useAudits'
import {useDataroom} from './hooks/useDataroom'
import {useActiveFrameworks} from './hooks/useActiveFrameworks'
import {useAuditActions} from './hooks/useAuditActions'
import {useAuditFilters} from './hooks/useAuditFilters'
import useAuditContext from 'app/Hooks/useAuditContext'
import EditAuditors from './components/drawer/EditAuditors'

const Audit = () => {
  const {currentUser} = useAuth()
  const [showAddaudit, setShowAddaudit] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalOpen2, setIsModalOpen2] = useState(false)
  const [auditID, setAuditID] = useState('')
  const [showCompleteModal, setShowCompleteModal] = useState(false)
  const [currentAuditId, setCurrentAuditId] = useState('')
  const [auditprop, setAuditProp] = useState<any>(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [toDeleteAudit, setToDeleteAudit] = useState<any>(null)
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const {audits, selectedFileName, setSelectedFileName, showEmptyState} = useAudits()
  const {dataroom} = useDataroom()
  const {activeFrameworks} = useActiveFrameworks()
  const { currentAuditContext } = useAuditContext()
  const {
    downloadLoading,
    selectedAuditId,
    isDeleting,
    triggerFileInputClick,
    handleDownloadReport,
    handleDownloadAuditReport,
    removeAudit,
    handleOpenAudit,
  } = useAuditActions(dataroom, setSelectedFileName)
  
  const {
    filteredAudits,
    searchTerm,
    setSearchTerm,
    searchLength,
    selectedFramework,
    setSelectedFramework,
    handleApplyFilter,
  } = useAuditFilters(audits)
  
  const auditForModal = audits.find((a) => a.id === currentAuditId) || auditprop

  const handleAudit = () => setShowAddaudit(true)
  const handleCloseAudit = () => setShowAddaudit(false)
  const handleOpenModal = (id: string) => {
    setIsModalOpen(true)
    setAuditID(id)
  }
  const handleEditAuditorsModal = (id: string) => {
    setIsModalOpen2(true)
    setAuditID(id)
  }
  const handleCloseModal = () => setIsModalOpen(false)
  const handleCloseModal2 = () => setIsModalOpen2(false)

  const handleMarkAsComplete = (auditId: string, audit: any) => {
    setCurrentAuditId(auditId)
    setAuditProp(audit)
    setShowCompleteModal(true)
  }

  const handleDelete = async (audit: any) => {
    setToDeleteAudit(audit)
    setIsDeleteModalOpen(true)
  }

  const handleRemoveAudit = async () => {
    await removeAudit(toDeleteAudit)
    setIsDeleteModalOpen(false)
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  const handleFrameworkChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedFramework(e.target.value)
    handleApplyFilter(e)
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Audits</title>
      </Helmet>
      
      <AddAudit isOpen={showAddaudit} onClose={handleCloseAudit} />
      
      <AuditHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedFramework={selectedFramework}
        onFrameworkChange={handleFrameworkChange}
        activeFrameworks={activeFrameworks}
        onAddAudit={handleAudit}
        currentUserRole={currentUser?.role}
        currentAuditContext={currentAuditContext}
      />

      {filteredAudits && filteredAudits.length > 0 ? (
        filteredAudits.map((audit) => (
          <AuditCard
            key={audit.id}
            audit={audit}
            currentUser={currentUser}
            downloadLoading={downloadLoading}
            selectedAuditId={selectedAuditId}
            selectedFileName={selectedFileName}
            onEditAudit={handleOpenModal}
            onUploadReport={triggerFileInputClick}
            onMarkComplete={handleMarkAsComplete}
            onDownloadAuditReport={handleDownloadAuditReport}
            onDownloadReport={handleDownloadReport}
            onDelete={handleDelete}
            onToggleDropdown={toggleDropdown}
            handleOpenAudit={handleOpenAudit}
            currentAuditContext={currentAuditContext}
            onEditAuditors={handleEditAuditorsModal}
          />
        ))
      ) : (
        <EmptyState
          type={searchLength ? 'no-results' : 'loading'}
          showEmptyState={showEmptyState}
        />
      )}

      <ToastContainer />
      
      <CompleteModal
        isOpen={showCompleteModal}
        onClose={() => setShowCompleteModal(false)}
        id={currentAuditId}
        audit={auditForModal}
        onComplete={() => setShowCompleteModal(false)}
        selectedFileName={selectedFileName}
      />
      
      {isDeleteModalOpen && (
        <ConfirmationModal
          isModalOpen={isDeleteModalOpen}
          hideModal={() => setIsDeleteModalOpen(false)}
          confirmBtnClickHandler={handleRemoveAudit}
          toDeleteItemTitle={`${toDeleteAudit?.auditTitle}`}
          isLoading={isDeleting}
          type='delete'
          confirmButtonText='Delete Audit'
        />
      )}
      
      <EditAudit isOpen={isModalOpen} onClose={handleCloseModal} auditID={auditID} />
      <EditAuditors isOpen={isModalOpen2} onClose={handleCloseModal2} auditID={auditID} />
    </>
  )
}

export default Audit